import { CampaignImageType } from 'core/worldCup/raffleImages/types';
import { AspectRatio } from 'components/Dashboard/WorldCup/RaffleImages/RaffleImageSection';

type ImageSection = {
  type: CampaignImageType;
  titleId: string;
  aspectRatio: AspectRatio;
  requiredWidth?: number;
  requiredHeight?: number;
  helperTextId?: string;
};

export const BANNER_IMAGE_WIDTH = 2000;
export const BANNER_IMAGE_HEIGHT = 920;
export const BANNER_IMAGE_HELPER_TEXT_ID = 'Banner image must be 2000x920 px.';

export const IMAGE_SECTIONS: ImageSection[] = [
  {
    type: CampaignImageType.Banner,
    titleId: 'Initial Banner',
    aspectRatio: 'landscape',
    requiredWidth: BANNER_IMAGE_WIDTH,
    requiredHeight: BANNER_IMAGE_HEIGHT,
    helperTextId: BANNER_IMAGE_HELPER_TEXT_ID,
  },
  {
    type: CampaignImageType.Main,
    titleId: 'Main Raffle Image',
    aspectRatio: 'portrait',
  },
];
